import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
const AnalyticsReport = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState(null);
    const initialState = {
        report_name: "", report_type: "", parameters: {}, status: "Generated"
    };
    const [formData, setFormData] = useState(initialState);
// =================================
// LOAD REPORTS
// =================================
    const loadReports = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseUrl + "analytics-report/");
            setReports(res.data);
        } catch (error) {
            Swal.fire("Error", "Unable to load reports", "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadReports();
    }, []);
// =================================
// CHANGE
// =================================
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };
// =================================
// GENERATE REPORT
// =================================
    const generateReport = async () => {
        try {
            await axios.post(baseUrl + "analytics-report/", formData);
            Swal.fire("Success", "Report Generated Successfully", "success");
            setShow(false);
            setFormData(initialState);
            loadReports();
        } catch (error) {
            Swal.fire("Error", "Report Generation Failed", "error");
        }
    };
// =================================
// VIEW RESULT
// =================================
    const viewReport = (row) => {
        setSelected(row);
        setShow(true);
    };
// =================================
// SUMMARY
// =================================
    const total = reports.length;
    const completed = reports.filter(x => x.status === "Generated").length;
    const pending = reports.filter(x => x.status === "Pending").length;
    const columns = [{
        field: "id", headerName: "ID", width: 80
    }, {
        field: "report_name", headerName: "Report Name", flex: 1
    }, {
        field: "report_type", headerName: "Type", flex: 1
    }, {
        field: "status", headerName: "Status", width: 130
    }, {
        field: "generated_date", headerName: "Generated Date", width: 200
    }, {
        field: "action", headerName: "Action", width: 120, renderCell: (params) => (<Button

                size="sm"

                variant="info"

                onClick={() => viewReport(params.row)}

            >

                View

            </Button>)
    }];
    return (<>


            <Row className="mb-3">


                <Col md={4}>


                    <Card className="shadow">


                        <Card.Body>


                            <h6>
                                Total Reports
                            </h6>


                            <h2>

                                {total}

                            </h2>


                        </Card.Body>


                    </Card>


                </Col>


                <Col md={4}>


                    <Card className="shadow">


                        <Card.Body>


                            <h6>
                                Completed
                            </h6>


                            <h2>

                                {completed}

                            </h2>


                        </Card.Body>


                    </Card>


                </Col>


                <Col md={4}>


                    <Card className="shadow">


                        <Card.Body>


                            <h6>
                                Pending
                            </h6>


                            <h2>

                                {pending}

                            </h2>


                        </Card.Body>


                    </Card>


                </Col>


            </Row>


            <Card className="shadow">


                <Card.Header>


                    <Row>


                        <Col>

                            <h5>

                                Analytics Reports

                            </h5>


                        </Col>


                        <Col className="text-end">


                            <Button

                                variant="primary"

                                onClick={() => setShow(true)}

                            >

                                + Generate Report

                            </Button>


                        </Col>


                    </Row>


                </Card.Header>


                <Card.Body>


                    <div

                        style={{
                            height: 500
                        }}

                    >


                        <ERPDataGrid


                            rows={reports}


                            columns={columns}


                            loading={loading}


                        />


                    </div>


                </Card.Body>


            </Card>


            <Modal

                show={show}

                onHide={() => setShow(false)}

                size="lg"

            >


                <Modal.Header closeButton>


                    <Modal.Title>

                        {selected ? "Report Result" : "Generate Report"}

                    </Modal.Title>


                </Modal.Header>


                <Modal.Body>


                    {selected ? <pre>

{JSON.stringify(selected.result, null, 4)}

</pre> : <Form>


                        <Form.Group>


                            <Form.Label>

                                Report Name

                            </Form.Label>


                            <Form.Control

                                name="report_name"

                                value={formData.report_name}

                                onChange={handleChange}

                            />


                        </Form.Group>


                        <Form.Group className="mt-3">


                            <Form.Label>

                                Report Type

                            </Form.Label>


                            <Form.Select

                                name="report_type"

                                value={formData.report_type}

                                onChange={handleChange}

                            >


                                <option>

                                    Select

                                </option>


                                <option>

                                    Crop Analysis

                                </option>


                                <option>

                                    Production Analysis

                                </option>


                                <option>

                                    Inventory Analysis

                                </option>


                                <option>

                                    Financial Analysis

                                </option>


                            </Form.Select>


                        </Form.Group>


                    </Form>}


                </Modal.Body>


                <Modal.Footer>


                    <Button

                        variant="secondary"

                        onClick={() => setShow(false)}

                    >

                        Close

                    </Button>


                    {!selected && <Button

                        variant="success"

                        onClick={generateReport}

                    >

                        Generate

                    </Button>}


                </Modal.Footer>


            </Modal>


        </>);
};
export default AnalyticsReport;